import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'hf-details-row',
  templateUrl: './details-row.component.html',
  styleUrls: ['./details-row.component.scss']
})
export class DetailsRowComponent {
  @Input()
  public label: string;

  @Input()
  public text: string;

  @Input()
  public additionalText: string;

  @Input()
  public showText?: boolean = true;

  @Input()
  public showOptInTemplate?: boolean;

  @Input()
  public optInValue: boolean;

  @Input()
  public showContactNote?: boolean = false;

  @Input()
  public contactNote?: string;

  @ContentChild('contentTemplate')
  contentTemplate: TemplateRef<any>;
}
